/* eslint-disable react/no-multi-comp */
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, Icon, Paragraph } from '@scentregroup/ui'
import { callToActionType } from '../../types'
import { GIFT_CARD_TEXT, AFTERPAY_TEXT } from '../../constants'
import { CountryContext } from '../../context'
import analyticsUtils from '../../helpers/analytics-utils'
import getGiftcardUrl from '../../helpers/get-giftcard-url'
import PriceRating from '../price-rating'
import StarRating from '../star-rating'
import Article from '../article'
import ExternalLink from '../external-link'
import style from './index.scss'
import CallToActionCategoryContainer from './call-to-action-category-container'

const offerWithIcon = {
  [GIFT_CARD_TEXT]: 'gift-cards',
  [AFTERPAY_TEXT]: 'afterpay',
}
// Move the above to constants once finalize CTA/offers (EG Deliveroo)

const Offerings = ({ offerings, title }) => (
  <CountryContext.Consumer>
    {country => (
      <Fragment>
        {offerings.map((offering, i) => (
          <div key={`offering-${i}`} className={style.storeFeatures}>
            <Icon className={style.icon} type={offerWithIcon[offering]} />
            <Paragraph>
              {offering === GIFT_CARD_TEXT ? (
                <ExternalLink
                  className={style.giftcardLink}
                  url={getGiftcardUrl(country)}
                  eventCategory={analyticsUtils.categories.GIFTCARD_CLICK}
                  eventAction={analyticsUtils.actions.GIFTCARD_STOREFRONT_CLICK}
                  eventLabel={title}
                  rel="noopener"
                >
                  {offering}
                </ExternalLink>
              ) : (
                <Paragraph> {offering} </Paragraph>
              )}
            </Paragraph>
          </div>
        ))}
      </Fragment>
    )}
  </CountryContext.Consumer>
)

const Services = ({ services }, context) =>
  services.map((service, i) => (
    <span key={`offering-${i}`} className={style.storeFeatures}>
      <Icon className={style.icon} type="tick-circle" />
      <Paragraph>{service}</Paragraph>
    </span>
  ))

const RetailerFeature = ({
  hashtags,
  offerings,
  services,
  priceRating,
  starRating,
  menuLink,
  reviewCount,
  topic,
  title,
  body,
  className,
  callsToAction,
  giftCardText,
}) => (
  <Card className={className}>
    <Article superheading={topic} heading={title} dataTestId="store-name">
      <div className={style.ratings}>
        {priceRating && <PriceRating priceRating={priceRating} />}
        {starRating && (
          <StarRating starRating={starRating} reviewCount={reviewCount} />
        )}
      </div>

      {body}
      {menuLink && (
        <Button type="primary" className={style.button}>
          View Menu
        </Button>
      )}
      {offerings.length > 0 && (
        <Fragment>
          <div className={style.storeFeaturesDivider} />
          <Offerings offerings={offerings} title={title} />
        </Fragment>
      )}
      {services.length > 0 && (
        <Fragment>
          <div className={style.storeFeaturesDivider} />
          <Services services={services} title={title} />
        </Fragment>
      )}
      {hashtags && (
        <Paragraph className={style.hashtags} data-test-id="store-description">
          {hashtags.map((hashtag, i) => (
            <span key={`hashtag-${i}`}>{hashtag}</span>
          ))}
        </Paragraph>
      )}

      {callsToAction && (
        <CallToActionCategoryContainer callsToAction={callsToAction} />
      )}
    </Article>
  </Card>
)

RetailerFeature.propTypes = {
  body: PropTypes.node,
  hashtags: PropTypes.array,
  services: PropTypes.array,
  offerings: PropTypes.array,
  menuLink: PropTypes.string,
  priceRating: PropTypes.number,
  reviewCount: PropTypes.number,
  starRating: PropTypes.number,
  topic: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  callsToAction: callToActionType,
  giftCardText: PropTypes.string,
}

RetailerFeature.defaultProps = {
  offerings: [],
  services: [],
}
Offerings.propTypes = {
  offerings: PropTypes.array,
  title: PropTypes.string,
}

Services.propTypes = {
  services: PropTypes.array,
}

export default RetailerFeature
